<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "RingPieEchart",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "",
    },
    yAxisName: {
      type: String,
      default: "",
    },
    legendData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions(val) {
      var datas = val.data || [];

      var color = [
        "#2ca1ff",
        "#0adbfa",
        "#febe13",
        "#65e5dd",
        "#7b2cff",
        "#fd5151",
        "#f071ff",
        "#85f67a",
        "#3682e1",
        "#35d789",
        "#f94a5c",
      ];

      const option = {
        backgroundColor: "transparent",
        color: color,
        tooltip: {
          show: true,
          confine: true,
          formatter: "{b}<br/>{c}({d}%)",
        },
        legend: {
          // type: "scroll",
          orient: "vertical",
          show: true,
          top: "center",
          left: "right",
          textStyle: {
            color: "#fff",
          },
          //  itemGap: 20,
          x: "center",
        },
        series: [
          {
            // name: '',
            type: "pie",
            clockwise: false, //时针方向
            radius: ["35%", "55%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                borderColor: "#031931",
                borderWidth: 3,
              },
            },
            labelLine: {
              // normal: {
              //   length: 20,
              //   length2: 20
              // },
              lineStyle: {
                // color: '#fff'//线色
              },
            },
            label: {
              show: true,
              normal: {
                show: true,
                formatter: "{d}%",
                color: "#fff", //字色
                fontSize: 14,
              },
              emphasis: {
                show: true,
              },
            },
            data: datas,
          },
        ],
      };

      this.chart.setOption(option);
    },
  },
};
</script>
